import { render } from "./ModalDescargaApp.vue?vue&type=template&id=06241a66&scoped=true"
import script from "./ModalDescargaApp.vue?vue&type=script&lang=js"
export * from "./ModalDescargaApp.vue?vue&type=script&lang=js"

import "./ModalDescargaApp.vue?vue&type=style&index=0&id=06241a66&scoped=true&lang=css"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06241a66"]])

export default __exports__